{
  "0_ALREADY_EXISTS": "\"{0}\" já existe.",
  "0_OF_1": "{0} de {1}",
  "ACCOUNT_ID": "ID da Conta",
  "ADD": "Adicionar",
  "ADD_REMOVE_FIELDS": "Adicionar/remover campos",
  "AN_ERROR_OCCURED": "Ocorreu um erro",
  "APPLY": "Aplicar",
  "APPLY_CHANGES": "Aplicar alterações",
  "ATTACH": "Anexar",
  "ATTACH_AS_LINK": "Anexar como Link",
  "ATTACHING": "Anexando...",
  "AUTOMATICALLY_RENAME": "Renomear automaticamente",
  "BACK": "Voltar",
  "BROWSE": "Procurar",
  "CANCEL": "Cancelar",
  "CHARACTER_COUNT": "Contagem de caracteres:",
  "CLOSE": "Fechar",
  "CLOUD": "Cloud",
  "COMMENT": "Comentário",
  "CONFIGURE_REPOSITORY_SETTINGS": "Configurar Configurações do Repositório",
  "COULD_NOT_SAVE_0": "Não foi possível salvar \"{0}\".",
  "COULD_NOT_SAVE_0_FILE_TYPE_NOT_SUPPORTED": "Não foi possível salvar \"{0}\". Tipo de arquivo não suportado.",
  "DATA": "Dados",
  "DATE": "Data",
  "DATE_FIELDS_MUST_BE_IN_FORMAT_0": "Os campos de data devem estar no formato {0}.",
  "DATE_PROVIDED_IS_INVALID": "A data fornecida é inválida.",
  "DATE_TIME": "Data/Hora",
  "DATE_TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Os campos de data/hora devem estar no formato {0}.",
  "DEFAULT_FOLDER": "<Pasta Padrão>",
  "DETAILS": "Detalhes",
  "DO_YOU_WANT_TO_APPLY_YOUR_FIELD_CHANGES": "Deseja aplicar suas alterações nos campos?",
  "DOCUMENT_NAME_IS_EMPTY": "O nome do documento está vazio",
  "DRAG_DROP_FILE": "Arraste e solte o arquivo",
  "ENTRY_0_ALREADY_EXISTS_SELECT_DIFFERENT_NAME": "Uma entrada chamada '{0}' já existe nesta pasta. Por favor, selecione um nome diferente.",
  "ENTRY_ID": "ID da entrada",
  "ENTRY_NAME": "Nome da Entrada",
  "ENTRY_NOT_FOUND": "Entrada não encontrada.",
  "ERROR_DOWNLOADING_DOCUMENT": "Erro ao baixar o documento.",
  "ERROR_OCCURRED_WHILE_CONNECTING_TO_SERVER": "Ocorreu um erro ao conectar ao servidor.",
  "ERROR_SAVING": "Erro ao salvar:",
  "FAILED_TO_OPEN_FOLDER": "Falha ao abrir a pasta",
  "FAILED_TO_SAVE_COLON": "Falha ao salvar:",
  "FAILED_TO_SAVE_PERIOD": "Falha ao salvar.",
  "FEEDBACK": "Feedback",
  "FIELDS": "Campos",
  "FILE_EXCEEDS_MAXIMUM_FILE_SIZE_25MB": "Este arquivo excede o tamanho máximo de arquivo de 25MB.",
  "FILE_EXTENSION": "Extensão do Arquivo",
  "FILE_LOCKED": "Arquivo está bloqueado.",
  "FILE_MODIFIED": "Arquivo Modificado",
  "FILE_NAME": "Nome do Arquivo",
  "FILENAMES_CANNOT_CONTAIN_BACKSLASH": "Nomes de arquivos não podem conter barra invertida",
  "FOLDER": "Pasta",
  "INTEGER": "Inteiro",
  "LIST": "Lista",
  "LOADING": "Carregando...",
  "LONG_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_3999999999": "Campos longos devem ser inteiros entre 0 e 3.999.999.999",
  "LONG_INTEGER": "Inteiro Longo",
  "NAME": "Nome",
  "NAME_CONFLICT": "Conflito de Nome",
  "NEED_HELP_SIGNING_IN_CONTACT_LASERFICHE_ADMINISTRATOR_FOR_HELP": "Precisa de ajuda para entrar? Contate seu Administrador Laserfiche para obter ajuda.",
  "NEW_FOLDER": "Nova Pasta",
  "NO": "Não",
  "NO_ADDITIONAL_FIELDS_ASSIGNED": "Nenhum campo adicional atribuído",
  "NO_FOLDER_SELECTED": "Nenhuma pasta está selecionada.",
  "NO_MATCHING_ENTRIES_FOUND": "Nenhuma entrada correspondente foi encontrada",
  "NO_MATCHING_FIELDS_FOUND": "Nenhum campo correspondente foi encontrado.",
  "NO_TEMPLATE_ASSIGNED": "Nenhum modelo atribuído",
  "NOT_AVAILABLE_WITH_TOKENS": "Não disponível com tokens",
  "NUMBER": "Número",
  "NUMBER_FIELD_MUST_BE_VALID_NUMBER": "O campo numérico deve ser um número válido",
  "OK": "Ok",
  "ONE_OR_MORE_FIELDS_INVALID": "Um ou mais campos são inválidos.",
  "OPEN": "Abrir",
  "OPEN_IN_LASERFICHE": "Abrir no Laserfiche",
  "OPTIONAL": "Opcional",
  "OR": "ou",
  "PARENT_FIELD": "Campo Pai",
  "PARENT_ID": "ID do pai",
  "PARENT_NAME": "Nome do Pai",
  "PLEASE_SELECT_A_FOLDER": "Por favor, selecione uma pasta",
  "REASON_FOR_DOWNLOADING": "Motivo para Download",
  "REFRESH": "Atualizar",
  "REMOVE": "Remover",
  "REMOVE_REPOSITORY": "Remover Repositório?",
  "REPOSITORY": "Repositório",
  "REPOSITORY_COUNT": "Contagem de Repositórios",
  "REPOSITORY_ID": "ID do Repositório",
  "REPOSITORY_NAME": "Nome do Repositório",
  "REQUIRED": "Obrigatório",
  "REQUIRED_FIELD_IS_EMPTY": "Campo obrigatório está vazio",
  "SAVE_CHANGES": "Salvar Alterações",
  "SAVE_TO_LASERFICHE": "Salvar no Laserfiche",
  "SAVED_TO_LASERFICHE": "Salvo no Laserfiche",
  "SAVED_TO_LASERFICHE_COLON": "Salvo no Laserfiche:",
  "SAVED_WITH_MISSING_METADATA": "Salvo com metadados ausentes:",
  "SAVING": "Salvando...",
  "SEARCH_FIELDS": "Campos de pesquisa",
  "SELECT": "Selecionar",
  "SELECT_REASON": "Selecione um motivo",
  "SELF_HOSTED": "Auto-hospedado",
  "SESSION_COUNT": "Contagem de Sessões",
  "SETTINGS": "Configurações",
  "SHORT_FIELDS_MUST_BE_INTEGERS_BETWEEN_0_64999": "Campos curtos devem ser inteiros entre 0 e 64999",
  "SIGN_IN": "Entrar",
  "SIGN_IN_TO_LASERFICHE": "Entrar no Laserfiche",
  "SIGN_OUT": "Sair",
  "SIGNING_IN": "Entrando...",
  "SIGNING_OUT": "Saindo...",
  "SKIP_THIS_FILE": "Pular este arquivo",
  "SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER": "Algo deu errado. Por favor, tente novamente mais tarde.",
  "SUBMIT": "Enviar",
  "SUGGESTION": "Sugestão",
  "TEMPLATE": "Modelo",
  "TEMPLATE_HAS_FAILED_TO_LOAD": "O modelo falhou ao carregar.",
  "TEXT": "Texto",
  "THANK_YOU_FOR_SUBMISSION": "Obrigado pela sua submissão!",
  "THIS_FIELD_HAS_MAXIMUM_ALLOWED_LENGTH_0_CHARACTERS": "Este campo tem um comprimento máximo permitido de {0} caracteres.",
  "THIS_FOLDER_IS_EMPTY": "Esta pasta está vazia.",
  "TIME": "Hora",
  "TIME_FIELDS_MUST_BE_IN_FORMAT_0": "Os campos de hora devem estar no formato {0}.",
  "UNABLE_TO_LOAD_ALL_FIELDS": "Não foi possível carregar todos os campos:",
  "UNABLE_TO_RETRIEVE_REPOSITORY_INFORMATION": "Não foi possível recuperar informações do repositório:",
  "UNKNOWN_ERROR": "Erro Desconhecido.",
  "USER_NAME": "Nome do Usuário",
  "YES": "Sim"
}
